import { useQuery } from '@tanstack/react-query';

import { ZonePricingPlan } from 'src/features/zone/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/zone-pricing-plan/:planId/`;

type QueryFnType = typeof queryFn;
interface DTO {
    planId: string;
    parkingId: string;
}
const queryFn = ({ planId, parkingId }: DTO): Promise<ZonePricingPlan> => {
    return axios.get(formatResourcePath(RESOURCE, { planId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetZonePricingPlans };
